var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBolaWearables(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "35px",
    height: "35px",
    x: "0px",
    y: "0px",
    viewBox: "0 0 35 35",
    style: {
      enableBackground: "new 0 0 35 35"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#00748A;}\n\t.st1{fill:#FFFFFF;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "bola-revision") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-3",
    className: "st0",
    cx: 17.5,
    cy: 17.5,
    r: 17.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "C\\xEDrculo-del-Paciente"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-887.000000, -415.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "datos-paciente",
    transform: "translate(298.000000, 220.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ico-wearables",
    transform: "translate(589.000000, 195.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    className: "st1",
    d: "M21.2,21.5c-0.4-0.2-0.9,0.1-1.1,0.5c-0.1,0.3-0.4,0.6-0.9,0.6h-7.7c-0.5,0-0.8-0.4-0.8-0.8 v-8.4c0-0.5,0.4-0.8,0.9-0.8h7.7c0.3,0,0.6,0.2,0.7,0.4c0.2,0.4,0.7,0.6,1.1,0.3c0.4-0.2,0.6-0.7,0.3-1.1 c-0.3-0.6-1-1.1-1.7-1.2l-0.2-2.1c-0.1-0.8-0.7-1.3-1.5-1.3h-5.7c-0.8,0-1.4,0.6-1.5,1.3l-0.2,2.2c-1.1,0.3-1.8,1.3-1.8,2.4 v8.4c0,1.1,0.8,2.1,1.8,2.4l0.2,2.2c0.1,0.8,0.7,1.3,1.5,1.3h5.7c0.8,0,1.4-0.6,1.5-1.3l0.2-2.1c0.9-0.2,1.6-0.8,1.9-1.6 C21.8,22.1,21.6,21.6,21.2,21.5L21.2,21.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M21.2,14c-0.5-0.1-0.9,0.2-1,0.6L18.9,20c-0.1,0.5,0.2,0.9,0.6,1c0.5,0.1,0.9-0.2,1-0.6l1.3-5.5 C21.9,14.5,21.6,14.1,21.2,14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M25.8,16.9L23.7,15c-0.3-0.3-0.9-0.3-1.2,0.1c-0.3,0.3-0.3,0.9,0.1,1.2l1.4,1.3l-1.4,1.3 c-0.3,0.3-0.4,0.8-0.1,1.2c0.2,0.2,0.4,0.3,0.6,0.3c0.2,0,0.4-0.1,0.6-0.2l2.1-1.9c0.2-0.2,0.3-0.4,0.3-0.6S26,17,25.8,16.9 L25.8,16.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M18.2,15c-0.3-0.3-0.8-0.4-1.2-0.1l-2.1,1.9c-0.2,0.2-0.3,0.4-0.3,0.6s0.1,0.5,0.3,0.6L17,20 c0.2,0.1,0.4,0.2,0.6,0.2c0.2,0,0.5-0.1,0.6-0.3c0.3-0.3,0.3-0.9-0.1-1.2l-1.4-1.3l1.4-1.3C18.5,15.9,18.5,15.4,18.2,15 L18.2,15z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBolaWearables);
export default __webpack_public_path__ + "static/media/bola-wearables.4455b6a4b61a218bdb588a59567be868.svg";
export { ForwardRef as ReactComponent };